export const WorkData = [
    {
        company: "Fujitsu Consulting India Pvt. Ltd.",
        designation: "Sr. Application Developer",
        dateOfJoining: "28 Mar 2024",
        dateOfLeaving: "Present",
        companyLogo: require("../../assets/logo/fujitsu.png"),
        work: "Working as Full-Stack Web developer use following technologies MongoDB, ExpressJS, NodeJS, ReactJS, NextJS"
    },
    {
        company: "Johnson Controls (India) Pvt. Ltd.",
        designation: "Sr. Software Engineer",
        dateOfJoining: "01 Sep 2022",
        dateOfLeaving: "29 Feb 2024",
        companyLogo: require("../../assets/logo/jci.jpg"),
        work: "Working on React & React Native technology. work as designing the components and API integration in the project."
    },
    {
        company: "ITWox Inc",
        designation: "Software Engineer",
        dateOfJoining: "20 Jul 2020",
        dateOfLeaving: "30 Aug 2022",
        companyLogo: require("../../assets/logo/itwox.jpg"),
        work: "Working on react native technology. work as designing the components and API integration in the project."
    },
    {
        company: "Varahi Technologies Pvt Ltd",
        designation: "Software Developer",
        dateOfJoining: "01 Jun 2018",
        dateOfLeaving: "20 Jun 2020",
        companyLogo: require("../../assets/logo/varahi.jpg"),
        work: "Working as a MERN stack & React Native technologies."
    }
]
